import { Api } from "../../common/lib/httpRequest";
import {
  GetSurveyOptionsResponse,
  CreateHealthCheckRequest,
  CreateHealthCheckResponse,
  GetHealthCheckInfoResponse
} from "../utils/types";

export const apiGetSurveyOptions = (params: any): Promise<GetSurveyOptionsResponse> => {
  return Api.get(`api/v2/user/account/ekyc-options`, params);
};

export const apiCreateHealthCheck = (data: CreateHealthCheckRequest): Promise<CreateHealthCheckResponse> => {
  return Api.post(`api/v2/user/account/ekyc`, data);
};

export const apiGetHealthCheckInfo = (): Promise<GetHealthCheckInfoResponse> => {
  return Api.get(`api/v1/user/account/existed-info`, null);
};